export enum SortOrderText {
    newest = "Senast",
    oldest = "Äldst",
    mostHits = "Flest träffar",
    leastHits = "Minst antal träffar",
    nameAscending = "Namn A-Ö",
    nameDescending = "Namn Ö-A"
}
